import { IconNames } from '@blueprintjs/icons';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';

import {
    type BasePayerRequestAdditonalData,
    BasePayerRequestNotification,
    type CommonPayerRequestNotificationProps,
} from 'components/notifications/BasePayerRequestNotification';
import { useAppSelector } from 'store';
import { useUserNameMap } from 'store/api/authApi';

export interface NewPayerRequestMessageNotificationProps extends CommonPayerRequestNotificationProps {
    small: boolean;
    additionalData: BasePayerRequestAdditonalData & {
        senderUpn: string;
    };
}

export const NewPayerRequestMessageNotification = ({
    linkingId,
    timestamp,
    additionalData,
    onNotificationClick,
    onRemoveNotificationClick,
    status,
    small,
    payerId,
}: NewPayerRequestMessageNotificationProps) => {
    const { payerId: userPayerId } = useAppSelector((state) => state.auth);

    const userNameMap = useUserNameMap({ payerId: userPayerId! });

    return (
        <BasePayerRequestNotification
            notificationTitle="New Message"
            icon={IconNames.CHAT}
            additionalDataComponent={
                <div className="flex__gap--small" style={{ flexDirection: 'column' }}>
                    <div className="sds_payer-request-notification__action-by">{`Sent by ${userNameMap?.[additionalData.senderUpn] || additionalData.senderUpn}`}</div>
                    {!small && (
                        <DetailLabelValuePair
                            label="Request #"
                            value={additionalData.requestNumber?.toString().padStart(6, '0')}
                        />
                    )}
                </div>
            }
            additionalData={additionalData}
            linkingId={linkingId}
            onNotificationClick={onNotificationClick}
            onRemoveNotificationClick={onRemoveNotificationClick}
            payerId={payerId}
            status={status}
            timestamp={timestamp}
        />
    );
};
